import React from "react";
import TrashDeleteIcon from "./assets/trash-delete.svg";
import EditIcon from "./assets/edit.svg";
import {
  ActionsContainer,
  DeleteButton,
  EditButton,
  DeleteIconContainer,
  EditIconContainer,
} from "./styles";

interface MissionItemActionsProps {
  onEdit: () => void;
  onDelete: () => void;
}

export const MissionItemActions = ({
  onEdit,
  onDelete,
}: MissionItemActionsProps) => (
  <ActionsContainer>
    <DeleteButton onClick={onDelete} title="Delete">
      <DeleteIconContainer>
        <img src={TrashDeleteIcon} alt="Delete" width={24} height={24} />
      </DeleteIconContainer>
    </DeleteButton>
    <EditButton onClick={onEdit} title="Edit">
      <EditIconContainer>
        <img src={EditIcon} alt="Edit" width={24} height={24} />
      </EditIconContainer>
    </EditButton>
  </ActionsContainer>
);
